import { Spinner } from '../LoadingSpinner/styles'
import * as S from './styles'

const LoadingCard = () => (
  <>
    <S.CardPlaceholder>
      <S.ImgPlaceholder>
        <div>
          <Spinner />
        </div>
      </S.ImgPlaceholder>
      <div className="placeholder-glow">
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7 me-2 mt-5"></span>
          <span className="placeholder col-4 me-2 mt-5"></span>
          <span className="placeholder col-4 me-2 mt-2"></span>
          <span className="placeholder col-6 me-2 mt-2"></span>
          <span className="placeholder col-8 me-2 mt-2"></span>
          <span className="placeholder col-3 me-2 mt-2"></span>
          <span className="placeholder col-4 me-2 mt-2"></span>
          <span className="placeholder col-6 me-2 mt-2"></span>
          <span className="placeholder col-8 me-2 mt-2"></span>
          <span className="placeholder col-3 me-2 mt-2"></span>
        </p>
      </div>
    </S.CardPlaceholder>
  </>
)

export default LoadingCard
